export default __webpack_public_path__ + "static/media/contact_majchrakova.fd346cf3.jpg";